import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export const UpdateBanner: React.FC = () => {
  // PWA update handling
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('SW Registered for Update Banner');
      // Check for updates immediately
      console.log('Checking for updates immediately...');
      r?.update();

      // Check for updates every 60 seconds
      setInterval(() => {
        console.log('Checking for updates...');
        r?.update();
      }, 60000);
    },
    onRegisterError(error) {
      console.log('SW registration error in Update Banner', error);
    },
  });

  const handleUpdateClick = () => {
    // Force hard reload to bypass all caches
    window.location.reload();
  };

  // Don't show if there's no update available
  if (!needRefresh) {
    return null;
  }

  // Don't show on PWA Manager page to avoid duplicate UI
  if (window.location.pathname === '/pwa-manager') {
    return null;
  }

  const styles = {
    overlay: {
      position: 'fixed' as const,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    },
    banner: {
      backgroundColor: '#22c55e',
      color: 'white',
      padding: '40px 32px',
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'center',
      gap: '24px',
      maxWidth: '500px',
      width: '100%',
      textAlign: 'center' as const
    },
    icon: {
      fontSize: '64px'
    },
    title: {
      fontSize: '24px',
      fontWeight: '700',
      margin: '0'
    },
    text: {
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '1.5',
      opacity: 0.95
    },
    button: {
      backgroundColor: 'white',
      border: 'none',
      color: '#22c55e',
      padding: '16px 48px',
      borderRadius: '12px',
      fontSize: '18px',
      fontWeight: '700',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
      width: '100%',
      justifyContent: 'center' as const,
      maxWidth: '300px'
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.banner}>
        <div style={styles.icon}>🚀</div>
        <h2 style={styles.title}>Update Available</h2>
        <div style={styles.text}>
          A new version of the app is ready. Please update now to get the latest features and improvements.
        </div>
        <button
          style={styles.button}
          onClick={handleUpdateClick}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
          }}
        >
          <RefreshCw size={20} />
          Update Now
        </button>
      </div>
    </div>
  );
};